const { ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_API } = process.env
export const DEFAULT_APP = '/saatchi/collectionsBrowse'
export const DEFAULT_URL = '/collections'
export const DEFAULT_URL_WITH_TRAILING_SLASH = '/collections/'
export const applicationId: string = ALGOLIA_APPLICATION_ID || ''
export const searchApi: string = ALGOLIA_SEARCH_API || ''
// const appEnv: string = APP_ENV || 'production'
export const searchIndice: string = `qa_all_collections`
// Curator Info constants
export const DEFAULT_AVATAR_IMAGE_URL =
  '//d3t95n9c6zzriw.cloudfront.net/common/profile/avatar_medium_square.jpg'
export const DEFAULT_CURATOR_NAME = 'Curator'
export const DEFAULT_CURATOR_TITLE = 'Curator at Saatchi Art'
// Tooltip constants
export const LOAD_MORE_TOOLTIP = 'Load more collections'
export const VIEW_PROFILE_TOOLTIP = 'View profile'
export const HOME_TOOLTIP = 'Home'
export const COLLECTION_TOOLTIP = 'Collections'
export const ALL_ARTWORKS_TOOLTIP = 'See all artworks'
export const SEE_MORE_TOOLTIP = 'See more New This Week'